// ===== SIDEBAR =====
// Fase 1: sidebar única (antes: ensureSidebarRailStructure() dividia #sidebar em
// #sb-rail (58px, ícones) + #sb-sub (234px, texto), ambos visíveis ao mesmo tempo).
// Os grupos/itens agora ficam direto dentro de #sidebar; o mesmo componente vira
// 272px (expandido, com texto) ou 72px (recolhido, só ícone + tooltip + flyout).
function aplicarTooltipsSidebar(){
  document.querySelectorAll('#sidebar .sb-group-hdr,#sidebar .sb-item').forEach(el=>{
    const label=el.querySelector('.sb-label')?.textContent?.trim();
    if(label)el.setAttribute('data-tooltip',label);
  });
}
aplicarTooltipsSidebar();
const SHELL_LAYOUT_VERSION='270';
let sbCollapsed=localStorage.getItem('sb-col')==='1';
if(localStorage.getItem('shell-layout-version')!==SHELL_LAYOUT_VERSION){sbCollapsed=false;localStorage.setItem('sb-col','0');localStorage.setItem('shell-layout-version',SHELL_LAYOUT_VERSION)}
function atualizarSbToggleA11y(){
  const btn=document.getElementById('sb-toggle');if(!btn)return;
  btn.setAttribute('aria-label',sbCollapsed?'Expandir menu lateral':'Recolher menu lateral');
  btn.setAttribute('aria-expanded',String(!sbCollapsed));
}
function toggleSidebar(){
  if(window.innerWidth<=768){document.body.classList.toggle('sb-open');return;}
  sbCollapsed=!sbCollapsed;
  document.body.classList.toggle('sb-collapsed',sbCollapsed);
  localStorage.setItem('sb-col',sbCollapsed?'1':'0');
  atualizarSbToggleA11y();
}
// Feedback do usuário: clicar num grupo/subgrupo com a sidebar recolhida
// (72px) deve reabrir a barra inteira, não abrir um flyout flutuante ao
// lado (removido — confundia, e tinha barra de rolagem indesejada).
function abrirSidebarAoInteragir(){
  if(window.innerWidth<=768){document.body.classList.add('sb-open');return;}
  if(sbCollapsed){
    sbCollapsed=false;
    document.body.classList.remove('sb-collapsed');
    localStorage.setItem('sb-col','0');
    atualizarSbToggleA11y();
  }
}
if(sbCollapsed)document.body.classList.add('sb-collapsed');
document.addEventListener('DOMContentLoaded',atualizarSbToggleA11y);
document.addEventListener('DOMContentLoaded',atualizarUiTema);
function _updateClock(){const el=document.getElementById('tb-clock');if(el)el.textContent=new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'})}
_updateClock();setInterval(_updateClock,30000);

